import React, { useState, useEffect, useContext } from 'react';
import UnderConstruction from './components/UnderConstruction';
import BrowserInfo from './components/BrowserInfo';
import UserTracker from './components/UserTracker';
import OverviewChart from './components/OverviewChart';
import { SessionContext } from './SessionContext';
import './App.css';

function App() {
  const [displayOverview, setDisplayOverview] = useState(false);
  const { userId, sessionId, clientIP } = useContext(SessionContext);

  useEffect(() => {
    const sanitizedClientIP = clientIP ? clientIP.replace(/\./g, '-') : '-'; // Replace dots with underscores
    (async function () {
      const response = await fetch(`/api/overview?id=${userId}&session=${sessionId}&clientIP=${sanitizedClientIP}`);
      const { shouldDisplayOverview } = await response.json();
      if (shouldDisplayOverview) { // Only set displayOverview if shouldDisplayOverview is true
        setDisplayOverview(true);
      }
    })();
  }, [userId, sessionId, clientIP]);

  const candlestickData = [
    { x: '2024-09-11', o: 100, h: 110, l: 90, c: 105 },
    { x: '2024-09-12', o: 105, h: 115, l: 95, c: 100 },
    { x: '2024-09-13', o: 100, h: 120, l: 80, c: 110 },
    { x: '2024-09-16', o: 110, h: 130, l: 100, c: 120 },
    { x: '2024-09-17', o: 120, h: 140, l: 110, c: 130 },
  ];

  
  return (
    <div className="app-container">
      {displayOverview ? (
        <div className="overview-container">
          <OverviewChart data={candlestickData} />
          <BrowserInfo />
          <UserTracker />
        </div>
      ) : (
        <UnderConstruction />
      )}
    </div>
  );
}

export default App;